<template>
    <div class="timesheet-employee-search" :class="{'timesheet-employee-search--active': api.employeeSearchActive, 'timesheet-employee-search--compact': compact}">
        <strong v-if="compact" class="timesheet-employee-search__heading" role="status" :aria-label="statusLabel">
            {{ api.employeeSearchActive ? filterCaption : 'Сотрудник' }}
        </strong>
        <label>
            <span class="sr-only">Поиск сотрудника в табеле</span>
            <input type="search" :value="api.employeeSearchText" placeholder="Поиск по ФИО" autocomplete="off"
                @input="api.changeEmployeeSearch($event.target.value)" @keydown.esc.prevent.stop="clear"
                @keydown.enter.prevent="api.flushEmployeeSearch()">
        </label>
        <div v-if="api.employeeSearchActive" class="timesheet-employee-search__status" role="status" aria-live="polite">
            <strong v-if="!compact" :aria-label="statusLabel">{{ filterCaption }}</strong>
            <button type="button" @click="clear">Показать всех</button>
        </div>
        <span v-if="api.employeeSearchNotice" class="timesheet-employee-search__notice" role="status">{{ api.employeeSearchNotice }}</span>
    </div>
</template>

<script>
export default {
    name: 'TimesheetEmployeeSearch',
    props: {api: {type: Object, required: true}, compact: {type: Boolean, default: false}},
    computed: {
        filterCaption() {
            return this.api.employeeSearchPending ? 'Фильтр: поиск…' : `Фильтр: ${this.api.filteredLines.length} из ${this.api.sortedLines.length}`;
        },
        statusLabel() {
            if (!this.api.employeeSearchActive) return 'Сотрудник';
            return this.api.employeeSearchPending ? 'Фильтр включён. Поиск…' : `Фильтр включён. Показаны ${this.api.filteredLines.length} из ${this.api.sortedLines.length}`;
        }
    },
    methods: {
        clear() {
            this.api.resetEmployeeSearch();
            this.$el.querySelector('input').focus({preventScroll: true});
        }
    }
};
</script>

<style>
.timesheet-employee-search { text-align: left; font-weight: normal; margin: 2px 0; }
.timesheet-employee-search__heading { display: block; margin-bottom: 2px; font-size: 13px; line-height: 17px; }
.timesheet-employee-search label { display: block; margin: 0; }
.timesheet-employee-search input { width: 100%; min-width: 0; height: 28px; padding: 2px 5px; border: 1px solid #8397ab; border-radius: 4px; background: #fff; color: #243746; font-size: 14px; }
.timesheet-employee-search input:focus { outline: 2px solid #0069b4; outline-offset: 1px; }
.timesheet-employee-search--active { padding: 3px; border: 1px solid #b36b00; border-radius: 5px; background: #fff2ce; color: #593500; }
.timesheet-employee-search--active input { background: #fff9eb; border: 2px solid #b36b00; }
.timesheet-employee-search__status { display: flex; flex-direction: column; gap: 2px; margin-top: 2px; font-size: 13px; line-height: 1.3; }
.timesheet-page .timesheet-employee-search .timesheet-employee-search__status button, .timesheet-page .timesheet-employee-search-empty button { padding: 5px 8px; border: 1px solid #8b5300; border-radius: 4px; background: #fff; color: #593500; font-size: 14px; font-weight: 600; }
.timesheet-page .timesheet-employee-search--compact .timesheet-employee-search__status button { padding: 2px 6px; line-height: 18px; min-height: 24px; }
.timesheet-employee-search__status button:focus, .timesheet-employee-search-empty button:focus { outline: 2px solid #0069b4; outline-offset: 1px; }
.timesheet-employee-search__notice { display: block; font-size: 13px; padding: 4px 0; white-space: normal; }
.timesheet-employee-search-empty { padding: 12px; background: #fff8e7; color: #593500; }
.timesheet-employee-search-empty button { margin: 4px 8px; }
@media (max-width: 720px) {
    .timesheet-employee-search { margin: 6px 0; }
    .timesheet-employee-search input { height: 36px; font-size: 16px; }
    .timesheet-employee-search__status { flex-direction: row; flex-wrap: wrap; align-items: center; gap: 4px 8px; font-size: 14px; }
    .timesheet-employee-search__status button { min-height: 36px; margin-left: auto; }
}
</style>
